import React from 'react';
import { Text } from 'src/kit';

import { EmailTaken } from './EmailTaken';

const customErrorMessagesMap = {
  email_taken: <EmailTaken />
};

export const renderCustomError = error => (
  <Text key={error} as="li" color="#a94442" fontWeight="light" textStyle="firstLetter">
    {customErrorMessagesMap[error] || error}
  </Text>
);
